(() => {
  // app/scripts/common/function/newsletter-popup.js
  var newsletter_popup = document.querySelector(".popup_container");
  var popup_inner = document.querySelector(".newsletter_popup");
  var overlay = document.querySelector(".popup_overlay");
  var popup_style = newsletter_popup.dataset.style;
  console.log("show_index", show_index);
  if (show_index == "true") {
    if (template == "index") {
      sessionStorage.setItem("popup", true);
    } else {
      sessionStorage.setItem("popup", false);
    }
  } else {
    console.log("haha");
    sessionStorage.setItem("popup", true);
  }
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:select", (e) => {
      if (e.detail.sectionId == section_id) {
        newsletter_popup.classList.remove("d-none");
        document.querySelector("body").classList.add("overflow-hidden");
      }
    });
  }
  showPopup = () => {
    let data = sessionStorage.getItem("popup");
    if (data == "true") {
      newsletter_popup.classList.remove("d-none");
      document.querySelector("body").classList.add("overflow-hidden");
    }
  };
  hidePopup = () => {
    newsletter_popup.classList.add("d-none");
    document.querySelector("body").classList.remove("overflow-hidden");
    sessionStorage.removeItem("popup");
    sessionStorage.setItem("popup", false);
  };
  var closeIcon = document.querySelector(".popup_exit");
  closeIcon.addEventListener("click", () => {
    hidePopup();
  });
  overlay.addEventListener("click", () => {
    hidePopup();
  });
  popup_inner.addEventListener("click", (e) => {
    e.stopPropagation();
  });
  if (popup_style == "time") {
    let timeout = parseInt(newsletter_popup.dataset.time);
    setTimeout(function() {
      showPopup();
    }, timeout * 1e3);
  }
  if (popup_style == "scroll") {
    let scroll_position = parseInt(newsletter_popup.dataset.scroll);
    let flag = true;
    window.addEventListener("scroll", () => {
      let newsletter_st = window.scrollY;
      if (newsletter_st > scroll_position) {
        if (flag) {
          showPopup();
          flag = false;
        }
      }
    });
  }
  if (popup_style == "exit") {
    document.addEventListener("mouseout", function(evt) {
      if (evt.toElement == null && evt.relatedTarget == null) {
        showPopup();
      }
      ;
    });
  }
})();
